const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const semVerLte = require('semver/functions/lte')

angular
  .module('surfsightApp.controllers')
  .controller('EventsFilterController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    'dataFromCaller',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      dataFromCaller
    ) {
      const firmwareVersion = dataFromCaller.edge.firmwareVersion
      $scope.items = angular
        .copy(deviceEventSettings)
        .filter(
          e =>
            (e.fromVersion
              ? semVerLte(e.fromVersion, firmwareVersion)
              : true) &&
            (e.toVersion ? semVerLte(firmwareVersion, e.toVersion) : true)
        )
      $scope.selected = [1]
      $scope.selected = dataFromCaller.selectedFilterEvents
      $scope.toggle = function (item, list) {
        var idx = -1
        list.forEach(function (l, itemIndex) {
          if (l.id == item.id) {
            idx = itemIndex
          }
        })
        if (idx > -1) {
          list.splice(idx, 1)
        } else {
          list.push(item)
        }
      }

      $scope.exists = function (item, list) {
        var returnValue = false
        list.forEach(function (i) {
          if (i.id == item.id) {
            returnValue = true
          }
        })
        return returnValue
      }

      $scope.isIndeterminate = function () {
        return (
          $scope.selected.length !== 0 &&
          $scope.selected.length !== $scope.items.length
        )
      }

      $scope.isChecked = function () {
        return $scope.selected.length === $scope.items.length
      }

      $scope.toggleAll = function () {
        if ($scope.selected.length === $scope.items.length) {
          $scope.selected = []
        } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
          $scope.selected = $scope.items.slice(0)
        }
      }
      $scope.selectedEvents = function () {
        // $scope.selectedEvents=$scope.selected;
        if ($scope.selected.length === $scope.items.length) {
          $mdDialog.hide($scope.selected)
        } else if ($scope.selected.length === 0) {
          $scope.selected = []
          $mdDialog.hide($scope.selected)
        } else {
          $mdDialog.hide($scope.selected)
        }
      }
      $scope.cancel = function () {
        // $scope.selectedEvents();
        // $mdDialog.cancel();
        $mdDialog.cancel($scope.selected)
      }
    }
  ])
